import React from 'react';
import { getImage } from '../../../../utils/imageHelper';
import { getConstant } from '../../../../utils/constants';
import DataTag from '../../../../components/Display/DataTag';
import styles from "../../cards.module.scss"

function ProductItem({ product, handleClickProduct, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${styles.projectCardSmall} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickProduct}>
      <img
        className={styles.projectImage}
        src={product.images[0]?.file ? product.images[0].file : getImage('img-ph.png')}
        alt={product.images[0]?.label ? product.images[0].label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{product.title}</p>
        </div>
        <div className={styles.tagList}>
          <DataTag key="type" tag={getConstant('dejademain.type', product.type)} large rounded />
        </div>
      </div>
    </div >
  );
}

export default ProductItem;
